import { createFileRoute } from '@tanstack/react-router'
import { useEffect } from 'react'
import z from 'zod'
import { useShallow } from 'zustand/react/shallow'
import { VerifyOtpForm } from '@/features/verify-otp-form'
import { useAuthStore } from '@/shared/store/auth-store'

const searchSchema = z.object({
  email: z.string().email(),
})

export const Route = createFileRoute('/_login/auth/set-password')({
  validateSearch: searchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const { email } = Route.useSearch()
  const { setUserWithOtp } = useAuthStore(
    useShallow((state) => ({
      setUserWithOtp: state.setUserWithOtp,
    }))
  )

  useEffect(() => {
    if (email) {
      setUserWithOtp(email)
    }
  }, [email, setUserWithOtp])

  return <VerifyOtpForm />
}
